import './CCFooter.css';

export default function CCFooter() {
    return (
        <div className="ccfooter-container">
            <div className="ccfooter-image"></div>
            <div className="ccfooter-wrapper">
                <div className="ccfooter-divider"></div>
                <div className="cc-footer-content-wrapper">
                    <div className="footer-content">
                        Wealthworthy is not affiliated with or endorsed by YouTube or Google.
                        Monetization and premium tier access are not included in this program and are only available to qualifying creators. Cash advances are subject to
                        channel performance and estimated earnings.
                    </div>
                </div>
            </div>
        </div >
    )
}